module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/covid19/pc/index/icon_app-l-4769016739aafd21610bf255ba38e1d4.png";